import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-learning3",
  "use": "icon-learning3-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol viewBox=\"0 0 50 50\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-learning3\">\r\n<path d=\"M14 31.5005L1.5984 18.8253C1.08667 18.3022 1.29153 17.4247 1.98194 17.1824L47.5356 1.19013C48.327 0.9123 49.0882 1.67353 48.8104 2.46492L32.8143 48.0293C32.5729 48.717 31.7005 48.9237 31.1762 48.4175L17.913 35.6116C17.5107 35.2233 17.5051 34.5805 17.9005 34.1851L28.1277 23.9579\" stroke=\"\" stroke-width=\"2\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/learning3.svg
// module id = 9km0
// module chunks = 23